import React from "react";
var __jsx = React.createElement;
import loadable from "@loadable/component";
import SelectedTags from "@/components/SearchComponent/UnbxdComponents/SelectedTags/SelectedTags";
import useFilterPage, { useSearchResultsData } from "@/pages/search/searchHooks/useSearchAndFilters";
var fallback = {
  fallback: null
};
var YearsSelectedTags = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "Years-YearsSelectedTags-YearsSelectedTags";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "Years-YearsSelectedTags-YearsSelectedTags" */"../Years/YearsSelectedTags/YearsSelectedTags");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../Years/YearsSelectedTags/YearsSelectedTags");
    }
    return eval('require.resolve')("../Years/YearsSelectedTags/YearsSelectedTags");
  }
}, fallback);
var YearsTags = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "Years-YearsTags-YearsTags";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "Years-YearsTags-YearsTags" */"../Years/YearsTags/YearsTags");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../Years/YearsTags/YearsTags");
    }
    return eval('require.resolve')("../Years/YearsTags/YearsTags");
  }
}, fallback);
var MakeModelYearTags = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "MakeModelYearTags-MakeModelYearTags";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "MakeModelYearTags-MakeModelYearTags" */"../MakeModelYearTags/MakeModelYearTags");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../MakeModelYearTags/MakeModelYearTags");
    }
    return eval('require.resolve')("../MakeModelYearTags/MakeModelYearTags");
  }
}, fallback);
var UnbxdSEOChips = function UnbxdSEOChips() {
  var _useFilterPage = useFilterPage(),
    isAutosPage = _useFilterPage.isAutosPage,
    isYearsPage = _useFilterPage.isYearsPage;
  var _useSearchResultsData = useSearchResultsData(),
    filters = _useSearchResultsData.filters,
    selectedOptions = _useSearchResultsData.selectedOptions,
    metaData = _useSearchResultsData.metaData;
  var showYearsTags = isYearsPage && filters.length > 4 || isAutosPage && filters.length > 4 && !selectedOptions.length;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isAutosPage && selectedOptions.length && filters.length > 4 ? /*#__PURE__*/React.createElement(SelectedTags, {
    className: "m-hide",
    tags: selectedOptions
  }) : null, isAutosPage && filters.length > 4 ? /*#__PURE__*/React.createElement(MakeModelYearTags, {
    className: "m-hide",
    selectedOptions: selectedOptions,
    filters: filters,
    metaData: metaData
  }) : null, isYearsPage && selectedOptions.length && filters.length > 4 ? /*#__PURE__*/React.createElement(YearsSelectedTags, {
    className: "m-hide",
    tags: selectedOptions
  }) : null, showYearsTags && /*#__PURE__*/React.createElement(YearsTags, {
    className: "m-hide",
    selectedOptions: selectedOptions,
    filters: filters,
    metaData: metaData
  }));
};
export default UnbxdSEOChips;